<template>
    <div>
        <label for="tenant_id" class="block text-sm font-medium text-gray-700">{{
            $t("tenants.forms.selector.title")
        }}</label>
        <select
            id="tenant_id"
            :value="modelValue"
            :class="{ 'border-red-500': errors }"
            name="tenant_id"
            class="
                mt-1
                block
                w-full
                pl-3
                pr-10
                py-2
                bg-white
                text-base
                border-gray-300
                focus:outline-none
                focus:ring-indigo-500
                focus:border-indigo-500
                sm:text-sm
                rounded-md
            "
            @change="$emit('update:modelValue', $event.target.value)"
        >
            <option selected disabled value="false">Selecteer een tenant</option>
            <option v-for="record in tenants" :key="record.id" :value="record.id">
                {{ record.name }}
            </option>
        </select>
        <ul v-if="errors">
            <li v-for="error in errors" :key="error" class="text-red-500 text-xs">
                {{ error }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "TenantSelector",
    props: {
        errors: {
            type: String,
            required: false,
        },
        tenants: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: String,
            required: true,
        },
    },
    emits: ["update:modelValue"],
};
</script>
